import _jsx from "@babel/runtime/helpers/jsx";
var _AjaxSpiner, _ConfirmationIcon;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Button from '../Button/index.js';
import AjaxSpiner from '../AjaxSpinner/index.js';
import ConfirmationIcon from './ConfirmationIcon.js';
function AnimatedButton(_ref) {
  let {
    buttonState = '',
    buttonText,
    loadedText,
    onClick,
    buttonWidth,
    className,
    ...rest
  } = _ref;
  let Content;
  switch (buttonState) {
    case 'loading':
      Content = _AjaxSpiner || (_AjaxSpiner = /*#__PURE__*/_jsx(AjaxSpiner, {}));
      break;
    case 'loaded':
      Content = /*#__PURE__*/React.createElement(React.Fragment, null, _ConfirmationIcon || (_ConfirmationIcon = /*#__PURE__*/_jsx(ConfirmationIcon, {})), /*#__PURE__*/_jsx("span", {
        className: "animated-text padding-left-2"
      }, void 0, loadedText));
      break;
    default:
      Content = buttonText;
  }
  const buttonClassName = clsx('display-inline-block btn-animated display-flex justify-content-center align-items-center', buttonState, className);
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    className: buttonClassName,
    onClick: onClick,
    style: {
      minWidth: buttonWidth
    }
  }, rest), Content);
}
export default AnimatedButton;